/** Heuristic: treat string as HTML for rich display (e.g. imported email bodies). */
export function looksLikeHtml(s: string | null | undefined): boolean {
  if (!s || typeof s !== 'string') return false;
  const t = s.trim();
  return t.startsWith('<') && /<[a-z][\s\S]*>/i.test(t);
}
